import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import { Filters } from "./Filters"
import Table from "./Table"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import {FiltersCard} from "../../../components/Common/FiltersCard";
import moment from "moment";
const Acca7 = props => {
    const [loadingMessage, setLoadingMessage] = useState("1");
    const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"))
    const [data, setData] = useState([])
    useEffect(() => {
        call()
    }, [])
    useEffect(() => {
        call()
    }, [selectedMonth])

    const call = () => {
      setLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/acca7-report?month=${selectedMonth}`,
        })
            .then(function (response) {
                setData(response?.data?.data)
                setLoadingMessage("0");
            })
            .catch(function (response) {
            })
    }


    return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="ACCA7 REPORT" />
        </Container>
          <Filters setSelectedMonth={setSelectedMonth} selectedMonth={selectedMonth}/>
          <Table data={data} loadingMessage={loadingMessage}  setLoadingMessage={setLoadingMessage}/>
      </div>
    </React.Fragment>
  )
}
export default withRouter(Acca7)
